import * as React from 'react';
import { ListItem as MatListItem, listItemClasses, SxProps, Theme } from '@mui/material';
import { archerConstants } from '../../utils';

export interface ListItemProps {
  alignItems?: 'flex-start' | 'center';
  autoFocus?: boolean;
  button?: boolean;
  children?: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onDoubleClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onBlur?: (event: React.FocusEvent) => void;
  onKeyUp?: (event: React.KeyboardEvent) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  onFocus?: (event: React.FocusEvent) => void;
  dense?: boolean;
  disabled?: boolean;
  disableGutters?: boolean;
  divider?: boolean;
  selected?: boolean;
  dataProp?: string;
  id?: string;
  component?: string;
  title?: string;
  role?: string;
  style?: React.CSSProperties;
  tabIndex?: number;
  disableRipple?: boolean;
  sx?: SxProps<Theme>;
}

const styles: Record<string, SxProps<Theme>> = {
  listItemHover: {
    [`&.${listItemClasses['button']}:hover`]: {
      backgroundColor: archerConstants.archerHover
    },
    [`&.${listItemClasses['button']}:active, &.${listItemClasses['button']}:focus`]: {
      backgroundColor: `${archerConstants.archerActive} !important`
    }
  }
};

const ListItem = React.forwardRef(
  (
    {
      alignItems,
      autoFocus,
      button,
      className,
      onClick,
      children,
      dense,
      disabled,
      disableGutters,
      divider,
      selected,
      dataProp,
      onBlur,
      onFocus,
      onKeyUp,
      onKeyDown,
      id,
      title,
      sx,
      ...rest
    }: ListItemProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    const { listItemHover } = styles;
    return (
      <MatListItem
        alignItems={alignItems}
        autoFocus={autoFocus}
        button={button as any}
        onClick={onClick}
        className={className}
        sx={[listItemHover, sx] as SxProps}
        dense={dense}
        disabled={disabled}
        disableGutters={disableGutters}
        divider={divider}
        selected={selected}
        data-selector={dataProp}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        id={id}
        title={title}
        ref={ref}
        {...rest}
      >
        {children}
      </MatListItem>
    );
  }
);

ListItem.displayName = 'ListItem';

export { ListItem };
